// // export default Dashboard;
import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import config from "../../../src/config/config";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  AvocatImage,
  Dash1,
  Dash2,
  Dash3,
  Dash4,
  Dropdown,
  OrangeImage,
  PineappleImage,
  EarpodIcon,
  Suppliers,
  StawberryImage,
  IphoneIcon,
  SamsungIcon,
  MacbookIcon,
  Employee,
} from "../../common/imagePath";

import { Table, Image } from "antd";
import "../../assets/node_modules_css/antd.css";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import CountUp from "react-countup";
import { Helmet } from "react-helmet";
import Sidebar from "./Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

import { checkUserPermission, getUserData } from "../../common/UserPermission";
import { toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE } from "../../common/Constant";
import Loader from "../../components/Loader/Loader";

let userDetails = {};

const Dashboard = (props) => {
  const history = useNavigate();
  const userDetails = getUserData();
  const locationvariable = JSON.parse(localStorage.getItem("LocationVariable"));
  const locationarray = locationvariable?.LocationName.split(",");
  const locationids = locationvariable?.LocationID;
  console.log(locationarray, "locationarray");
  console.log(locationids, "locationids");
  console.log("userDetails from dashboard", userDetails);
  // const history = useHistory();

  useEffect(() => {
    if (locationarray?.length == 1) {
      localStorage.setItem("Location", locationids);
      setLoading(true);
      axios
        .post(
          `${config.authenticationBaseUrl}/users/locationupsert`,
          {
            loginuserid: ID,
            locationid: locationids,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // console.log("res ==> ", res.data.ResponseData);

          //  toastSuccess(SUCCESS_MESSAGE);
          console.log(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [locationids]);

  const token = localStorage.getItem("Token");

  const PrivacyDashboard = localStorage.getItem("PrivacyDashboard");
  const currentDate = new Date();
  const firstDayOfYear = new Date(currentDate.getFullYear(), 0, 1);
  const lastDayOfYear = new Date(currentDate.getFullYear(), 11, 31);

  const ID = localStorage.getItem("ID");
  const defaultlocationid = localStorage.getItem("Location");
  const [showModal, setShowModal] = useState(false);
  const [invoicesamount, setInvoicesAmount] = useState(0);
  const [invoicescount, setInvoicesCount] = useState(0);
  const [billsamount, setBillsAmount] = useState(0);
  const [billscount, setBillsCount] = useState(0);
  const [customercount, setCustomerCount] = useState(0);
  const [suppliercount, setSupplierCount] = useState(0);
  const [employeecount, setEmployeeCount] = useState(0);
  const [taskcount, setTaskCount] = useState(0);
  const [pendinginvoicescount, setPendingInvoicesCount] = useState(0);
  const [pendinginvoicesamount, setPendingInvoicesAmount] = useState(0);
  const [pendingbillscount, setPendingBillsCount] = useState(0);
  const [pendingbillsamount, setPendingBillsAmount] = useState(0);
  const [itemcount, setItemCount] = useState(0);
  const [damageditemcount, setDamagedItemCount] = useState(0);
  const [inventorycount, setInventoryCount] = useState(0);
  const [outofstockcount, setOutOfStockCount] = useState(0);

  const [expiresoon, setExpiresoon] = useState();
  const [isContentVisible, setIsContentVisible] = useState(
    localStorage.getItem("PrivacyDashboard") === "1"
  );
  const [location, setLocation] = useState();
  const [name, setName] = useState("");
  const [startingDate, setStartingDate] = useState(
    moment(firstDayOfYear).format("YYYY-MM-DD")
  );
  const [endingDate, setEndingDate] = useState(
    moment(lastDayOfYear).format("YYYY-MM-DD")
  );

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [graphdata, setGraphData] = useState([]);
  const [loading, setLoading] = useState(false);

  let array = [];
  let purchasearray = [];

  const salesdata = graphdata?.map((item, index) =>
    array.push(item.SalesCount)
  );
  const purchasedata = graphdata?.map((item, index) =>
    purchasearray.push(item.PurchaseCount)
  );

  const state = {
    series: [
      {
        name: "Sales",
        data: array,
      },
      {
        name: "Purchase",
        data: purchasearray,
      },
    ],
    options: {
      colors: ["#28C76F", "#EA5455"],
      chart: {
        type: "bar",
        height: 300,
        stacked: true,

        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 280,
          options: {
            legend: {
              position: "bottom",
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "20%",
          borderRadius: 5,
          borderRadiusTop: 5,
        },
      },
      xaxis: {
        categories: [
          " Jan ",
          "feb",
          "march",
          "april",
          "may",
          "june",
          "july",
          "august",
          "september",
          "october",
          "november",
          "december",
        ],
      },
      legend: {
        position: "top",
      },
      fill: {
        opacity: 1,
      },
    },
  };

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    // marginBottom: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  const locationid = localStorage.getItem("Location");
  const handleToggleContent = () => {
    const newValue = !isContentVisible;
    setIsContentVisible(newValue);

    localStorage.setItem("PrivacyDashboard", newValue ? "1" : "0");
    console.log("Check of the toggle button", isContentVisible);
    // Make an API call to store the state in the database
    axios
      .post(`${config.authenticationBaseUrl}/users/updatedashboardtoggle`, {
        PrivacyDashboard: newValue ? 1 : 0,
        LoginUserId: ID,
      })
      .then((res) => {
        console.log("response of toggle", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleSearchAccordingToDate = () => {
    handleListData(locationid, startingDate, endingDate);
    handledata(locationid, startingDate, endingDate);
  };

  const handleQuickBookChange = (fieldName, event) => {
    // console.log("Value ==> ", event);
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate(moment(firstDayOfYear).format("YYYY-MM-DD"));
      setEndingDate(moment(lastDayOfYear).format("YYYY-MM-DD"));
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate("");
      setEndingDate("");
    }
    // Last Week Condition
    else if (event?.value == 3) {
      var currentDateForLastWeek = new Date();
      // console.log("currentDateForLastWeek ==> ", currentDateForLastWeek);
      // Set the date to the start of the current week (Sunday)
      var startOfWeekForLastWeek = new Date(
        currentDateForLastWeek.setDate(
          currentDateForLastWeek.getDate() - currentDateForLastWeek.getDay()
        )
      );
      // console.log("startOfWeekForLastWeek ==> ", startOfWeekForLastWeek);

      // Set the date to the end of the last week (Saturday)
      var endOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(startOfWeekForLastWeek.getDate() - 1)
      );
      // console.log("endOfLastWeekForLastWeek ==> ", endOfLastWeekForLastWeek);

      // Set the date to the start of the last week (Sunday)
      var startOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(endOfLastWeekForLastWeek.getDate() - 6)
      );

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForLastWeek = startOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      var endDateStringForLastWeek = endOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      // Output the results
      // console.log(
      //   "Last week started on " +
      //     startDateStringForLastWeek +
      //     " and ended on " +
      //     endDateStringForLastWeek
      // );
      setStartingDate(startDateStringForLastWeek);
      setEndingDate(endDateStringForLastWeek);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      var currentDateForCurrentWeek = new Date();
      // console.log("currentDateForCurrentWeek ==> ", currentDateForCurrentWeek);

      // Set the date to the start of the current week (Sunday)
      var startOfWeekForCurrentWeek = new Date(
        currentDateForCurrentWeek.getTime() -
          currentDateForCurrentWeek.getDay() * 24 * 60 * 60 * 1000
      );
      // console.log("startOfWeekForCurrentWeek ==> ", startOfWeekForCurrentWeek);

      // Set the date to the end of the current week (Saturday)
      var endOfWeekForCurrentWeek = new Date(
        startOfWeekForCurrentWeek.getTime() + 6 * 24 * 60 * 60 * 1000
      );
      // console.log("endOfWeekForCurrentWeek ==> ", endOfWeekForCurrentWeek);

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForCurrentWeek = startOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      var endDateStringForCurrentWeek = endOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   "Current week started on " +
      //     startDateStringForCurrentWeek +
      //     " and ended on " +
      //     endDateStringForCurrentWeek
      // );

      setStartingDate(startDateStringForCurrentWeek);
      setEndingDate(endDateStringForCurrentWeek);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      // Get today's date
      const todayForLastMonth = new Date();

      // Get the first day of the current month
      const firstDayCurrentMonthForLastMonth = new Date(
        todayForLastMonth.getFullYear(),
        todayForLastMonth.getMonth(),
        1
      );

      // Get the last day of the previous month
      const lastDayPrevMonthForLastMonth = new Date(
        firstDayCurrentMonthForLastMonth.getTime() - 1
      );

      // Get the starting date of the previous month
      const firstDayPrevMonthForLastMonth = new Date(
        lastDayPrevMonthForLastMonth.getFullYear(),
        lastDayPrevMonthForLastMonth.getMonth(),
        1
      );

      // Format the starting and ending dates of the previous month as yyyy-mm-dd
      const startDateFormattedForLastMonth = firstDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForLastMonth = lastDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of last month: ${startDateFormattedForLastMonth}`
      // );
      // console.log(`Ending date of last month: ${endDateFormattedForLastMonth}`);
      setStartingDate(startDateFormattedForLastMonth);
      setEndingDate(endDateFormattedForLastMonth);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      // Get today's date
      const todayForCurrentMonth = new Date();

      // Get the first day of the current month
      const firstDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth(),
        1
      );

      // Get the last day of the current month
      const lastDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth() + 1,
        0
      );

      // Format the starting and ending dates of the current month as yyyy-mm-dd
      const startDateFormattedForCurrentMonth = firstDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForCurrentMonth = lastDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of current month: ${startDateFormattedForCurrentMonth}`
      // );
      // console.log(
      //   `Ending date of current month: ${endDateFormattedForCurrentMonth}`
      // );
      setStartingDate(startDateFormattedForCurrentMonth);
      setEndingDate(endDateFormattedForCurrentMonth);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "30px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     // backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     // "&:hover": {
  //     //   backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     // },
  //   }),
  // };

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  const [expiredData] = useState([
    {
      key: 1,
      code: "IT001",
      image: OrangeImage,
      productName: "Orange",
      brandName: "N/D",
      categoryName: "Fruits",
      expiryDate: "12-12-2022",
    },
    {
      key: 2,
      code: "IT002",
      image: PineappleImage,
      productName: "Pineapple",
      brandName: "N/D",
      categoryName: "Fruits",
      expiryDate: "10-12-2022",
    },
    {
      key: 3,
      code: "IT003",
      image: StawberryImage,
      productName: "Stawberry",
      brandName: "N/D",
      categoryName: "Fruits",
      expiryDate: "27-06-2022",
    },
    {
      key: 4,
      code: "IT004",
      image: AvocatImage,
      productName: "Avocat",
      brandName: "N/D",
      categoryName: "Fruits",
      expiryDate: "20-05-2022",
    },
  ]);

  const [recentData] = useState([
    { key: 1, image: EarpodIcon, products: "Apple Earpods", price: "$891.2" },
    { key: 2, image: IphoneIcon, products: "iPhone 11", price: "$91.2" },
    { key: 3, image: SamsungIcon, products: "Samsung", price: "$561.2" },
    { key: 4, image: MacbookIcon, products: "Macbook Pro", price: "$1009.2" },
  ]);

  function handleCustomers() {
    history("/customers");
  }

  function handleSuppliers() {
    history("/suppliers");
  }

  function handleEmployees() {
    history("/employees");
  }

  function handleItems() {
    history("/items");
  }

  function handleItemkits() {
    history("/item-Kits");
  }

  function handlePurchaseInvoice() {
    history("/error403");
  }
  function handleSalesInvoice() {
    history("/sales");
  }
  function handleAppointments() {
    history("/appointments");
  }
  function handleViewItems() {
    history("/items");
  }

  const handleListData = (locationid, startingdate, endingdate) => {
    axios
      .get(
        `${config.generalBaseUrl}/generals/dashboardCount?locationid=${locationid}&startdate=${startingdate}&enddate=${endingdate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("Heloooooooo", res);
        // Calculate counts only once when the data is first loaded
        setInvoicesAmount(res.data.ResponseData[0].InvoicesAmount);
        setInvoicesCount(res.data.ResponseData[0].InvoicesCount);
        setBillsAmount(res.data.ResponseData[0].BillsAmount);
        setBillsCount(res.data.ResponseData[0].BillsCount);
        setCustomerCount(res.data.ResponseData[0].CustomerCount);
        setSupplierCount(res.data.ResponseData[0].SupplierCount);
        setEmployeeCount(res.data.ResponseData[0].EmployeeCount);
        setTaskCount(res.data.ResponseData[0].TaskCount);
        setPendingInvoicesCount(res.data.ResponseData[0].PendingInvoicesCount);
        setPendingInvoicesAmount(
          res.data.ResponseData[0].PendingInvoicesAmount
        );
        setPendingBillsCount(res.data.ResponseData[0].PendingBillsCount);
        setPendingBillsAmount(res.data.ResponseData[0].PendingBillsAmount);
        setItemCount(res.data.ResponseData[0].ItemCount);
        setDamagedItemCount(res.data.ResponseData[0].DamagedItemsCount);
        setOutOfStockCount(res.data.ResponseData[0].OutofstockItemsCount);
        setInventoryCount(res.data.ResponseData[0].InventoryAlertCount);
      })
      .catch((err) => {
        console.log("Error: ", err);
      });
  };

  useEffect(() => {
    // Set PrivacyDashboard in localStorage when the component mounts
    localStorage.setItem("PrivacyDashboard", isContentVisible ? "1" : "0");
    // Binding Customer Fields

    // setStartingDate(firstDayOfYear)
    handleListData(locationid, startingDate, endingDate);
  }, [isContentVisible, quickBookOptions]);

  // For Modal
  useEffect(() => {
    console.log(localStorage.getItem("Location"), "pppp");
    // const locationvalue= localStorage.getItem("Location")
    if (localStorage.getItem("Location") == null) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  }, []);

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //currentmonth
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);

  const handledata = (locationid, startingdate, endingdate) => {
    axios
      .get(
        `${config.generalBaseUrl}/generals/dashboardsalespurchasereport?locationid=${locationid}&startdate=${startingdate}&enddate=${endingdate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setGraphData(res.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    handledata(locationid, startingDate, endingDate);
  }, [quickBookOptions]);

  const storedData = localStorage.getItem("LocationVariable");
  const parsedData = JSON.parse(storedData);
  const locationNames = parsedData?.LocationName?.split(",");
  const locationIDs = parsedData?.LocationID?.split(",");

  const locations = locationNames?.map((name, index) => ({
    LocationName: name.trim(),
    LocationID: locationIDs[index].trim(),
  }));

  const handleModalSubmit = (locationID, name) => {
    // console.log(name,"name")
    localStorage.setItem("Location", locationID);
    localStorage.setItem("LocationName", name);
    // localStorage.removeItem("LocationVariable");
    // window.location.reload();
    setLoading(true);
    axios
      .post(
        `${config.authenticationBaseUrl}/users/locationupsert`,
        {
          loginuserid: ID,
          locationid: locationID,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        // toastSuccess(SUCCESS_MESSAGE);
        // console.log(res.data)
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    setShowModal(false);
  };
  // For Modal

  const expiredProductColumns = [
    {
      title: "SNo",
      dataIndex: "key",
      sorter: (a, b) => a.key.length - b.key.length,
    },
    {
      title: "Product Code",
      dataIndex: "code",
      render: (text, record) => (
        <Link to="#" style={{ fontSize: "14px" }}>
          {text}
        </Link>
      ),
      sorter: (a, b) => a.code.length - b.code.length,
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      render: (text, record) => (
        <div className="productimgname">
          <Link to="#" className="product-img">
            <img alt="" src={record.image} />
          </Link>
          <Link to="#" style={{ fontSize: "14px" }}>
            {record.productName}
          </Link>
        </div>
      ),
      sorter: (a, b) => a.productName.length - b.productName.length,
    },
    {
      title: "Brand Name",
      dataIndex: "brandName",
      render: (text, record) => <div style={{ fontSize: "14px" }}>{text}</div>,
      sorter: (a, b) => a.brandName.length - b.brandName.length,
    },
    {
      title: "Category Name",
      dataIndex: "categoryName",
      render: (text, record) => <div style={{ fontSize: "14px" }}>{text}</div>,
      sorter: (a, b) => a.categoryName.length - b.categoryName.length,
    },
    {
      title: "Expiry Date",
      dataIndex: "expiryDate",
      render: (text, record) => <div style={{ fontSize: "14px" }}>{text}</div>,
      sorter: (a, b) => a.expiryDate.length - b.expiryDate.length,
    },
  ];
  const dataSource = Array.isArray(expiresoon)
    ? expiresoon?.map((item, index) => ({
        key: index + 1,
        name: item.Name,
        date: new Date(item.Date).toLocaleDateString(),
        imageName: item.ImageName,
      }))
    : [];

  console.log(location);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <Helmet>
          <title>Sonar POS</title>
          <meta name="description" content="Dashboard page" />
        </Helmet>
        <div className="content">
          <div className="row">
            {isContentVisible === true ? (
              <>
                <div className=" col-lg-2 col-md-6 col-sm-12 mt-4">
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange("ExcelExport", event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={selectStyles}
                    id="ExcelExport"
                    name="ExcelExport"
                    className="ml-2 custom-search-select"
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                      Custom Start Date:
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                      />
                    </div>
                    <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                      Custom End Date:
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                      />
                    </div>
                    <div className="col-lg-1 col-md-6 col-sm-12 mt-4">
                      <button
                        className="btn btn-dark btn-sm"
                        onClick={() => handleSearchAccordingToDate()}
                      >
                        Search
                      </button>
                    </div>
                  </>
                )}
              </>
            ) : null}

            {quickBookOptions?.value !== 2 && (
              <>
                <div className="p-3 col-lg-5 col-md-3 col-sm-12 "></div>
              </>
            )}

            {/* {quickBookOptions?.value !== 2 && (
            <div className="p-2 mt-3 col-lg-2 col-md-6 col-sm-12 border border-primary "></div>
             )} */}
            <div className="col-lg-5 col-sm-6 col-12  ">
              {userDetails &&
              userDetails.RoleType &&
              userDetails.RoleType.toUpperCase() === "SUPERADMIN" ? (
                <div className="pull-right form-check form-switch mb-3 mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="toggle-button"
                    checked={isContentVisible}
                    onChange={handleToggleContent}
                  />
                  <label className="form-check-label" htmlFor="toggle-button">
                    {isContentVisible ? "Hide Dashboard" : "Show Dashboard"}
                  </label>
                </div>
              ) : null}
            </div>
          </div>
          {isContentVisible === true && (
            <div id="hello-message">
              <div
                className="row"
                style={{
                  display: "grid",
                  gap: "1rem",
                  // gridTemplateColumns: "repeat(5,1fr)"
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <Link to="/sales">
                    <div className="dash-widget" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <img src={Dash1} alt="img" />
                        </span>
                      </div>

                      <div className="dash-widgetcontent">
                        <h5>
                          $
                          <span className="counters">
                            <CountUp end={invoicesamount} />
                          </span>
                        </h5>
                        <div className="d-flex">
                          <span>{invoicescount}</span>
                          <h6 className="ml-2">Invoices</h6>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="cards">
                  <Link to="/receiving">
                    <div className="dash-widget dash1" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <img src={Dash2} alt="img" />
                        </span>
                      </div>

                      <div className="dash-widgetcontent">
                        <h5>
                          $
                          <span className="counters">
                            <CountUp end={billsamount} />
                          </span>
                        </h5>
                        <div className="d-flex">
                          <span>{billscount}</span>
                          <h6 className="ml-2">Bills</h6>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="cards">
                  <Link to="/customers">
                    <div className="dash-widget dash2" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <i
                            className="fa fa-users"
                            style={{ color: "#FF9F43", fontSize: "large" }}
                          />
                        </span>
                      </div>

                      <div className="dash-widgetcontent">
                        <h5>
                          <span className="counters">
                            <CountUp end={customercount} />
                          </span>
                        </h5>
                        <h6>Customer</h6>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="cards">
                  <Link to="/suppliers">
                    <div className="dash-widget dash3" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          {/* <img src={Suppliers} alt="img" width="65%"/> */}
                          <i
                            className="fa fa-child"
                            style={{ color: "#FF9F43", fontSize: "large" }}
                          />
                        </span>
                      </div>
                      <div className="dash-widgetcontent">
                        <h5>
                          <span className="counters">
                            <CountUp end={suppliercount} />
                          </span>
                        </h5>
                        <h6>Supplier</h6>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="cards">
                  <Link to="/employees">
                    <div className="dash-widget dash3" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <i
                            className="fa fa-child"
                            style={{ color: "#FF9F43", fontSize: "large" }}
                          />
                        </span>
                      </div>

                      <div className="dash-widgetcontent">
                        <h5>
                          <span className="counters">
                            <CountUp end={employeecount} />
                          </span>
                        </h5>
                        <h6>Employee</h6>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="cards">
                  <Link to="/task">
                    <div className="dash-widget dash3" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <i
                            className="fa fa-edit"
                            style={{ color: "#FF9F43", fontSize: "large" }}
                          />
                        </span>
                      </div>
                      <div className="dash-widgetcontent">
                        <h5>
                          <span className="counters">
                            <CountUp end={taskcount} />
                          </span>
                        </h5>
                        <h6>Task</h6>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="cards">
                  <Link to="/sales">
                    <div className="dash-widget" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <img src={Dash1} alt="img" />
                        </span>
                      </div>
                      <div className="dash-widgetcontent">
                        <h5>
                          $
                          <span className="counters">
                            <CountUp end={pendinginvoicesamount} />
                          </span>
                        </h5>
                        <div className="d-flex">
                          <span>{pendinginvoicescount}</span>
                          <h6 className="ml-2">Pending Invoices</h6>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="cards">
                  <Link to="/receiving">
                    <div className="dash-widget" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <img src={Dash2} alt="img" />
                        </span>
                      </div>
                      <div className="dash-widgetcontent">
                        <h5>
                          $
                          <span className="counters">
                            <CountUp end={pendingbillsamount} />
                          </span>
                        </h5>
                        <div className="d-flex">
                          <span>{pendingbillscount}</span>
                          <h6 className="ml-2">Pending Bills</h6>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="cards">
                  <Link to="/items">
                    <div className="dash-widget dash2" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <i
                            className="fa fa-shopping-bag"
                            style={{ color: "#FF9F43", fontSize: "large" }}
                          />
                        </span>
                      </div>
                      <div className="dash-widgetcontent">
                        <h5>
                          <span className="counters">
                            <CountUp end={damageditemcount} />
                          </span>
                        </h5>
                        <div className="d-flex">
                          <h6>Item</h6>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="cards">
                  <div className="dash-widget dash3" style={dashStyle}>
                    <div className="dash-widgetimg">
                      <span>
                        <i
                          className="fa fa-shopping-bag"
                          style={{ color: "#FF9F43", fontSize: "large" }}
                        />
                      </span>
                    </div>
                    <div className="dash-widgetcontent">
                      <h5>
                        <span className="counters">
                          <CountUp end={damageditemcount} />
                        </span>
                      </h5>
                      <h6>Damaged Items</h6>
                    </div>
                  </div>
                </div>

                <div className="cards">
                  <Link to="/items">
                    <div className="dash-widget dash3" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <i
                            className="fa fa-shopping-bag"
                            style={{ color: "#FF9F43", fontSize: "large" }}
                          />
                        </span>
                      </div>
                      <div className="dash-widgetcontent ">
                        <h5>
                          <span className="counters">
                            <CountUp end={outofstockcount} />
                          </span>
                        </h5>
                        <h6>Out of stock Items</h6>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="cards">
                  <Link to="/items">
                    <div className="dash-widget dash3" style={dashStyle}>
                      <div className="dash-widgetimg">
                        <span>
                          <i
                            className="fa fa-shopping-bag"
                            style={{ color: "#FF9F43", fontSize: "large" }}
                          />
                        </span>
                      </div>
                      <div className="dash-widgetcontent">
                        <h5>
                          <span className="counters">
                            <CountUp end={inventorycount} />
                          </span>
                        </h5>
                        <h6>Inventory Alert</h6>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

              {/* Button trigger modal */}
              <div className="row">
                <div className="col-lg-12 col-sm-12 col-12 d-flex">
                  <div className="card flex-fill">
                    <div className="card-header pb-0 d-flex justify-content-between align-items-center">
                      <h5 className="card-title mb-0">Purchase &amp; Sales</h5>
                      {/* <div className="graph-sets">
                        <div className="dropdown">
                          <button
                            className="btn btn-white btn-sm dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            2022
                            <img src={Dropdown} alt="img" className="ms-2" />
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <li>
                              <Link to="#" className="dropdown-item">
                                2022
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item">
                                2021
                              </Link>
                            </li>
                            <li>
                              <Link to="#" className="dropdown-item">
                                2020
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div> */}
                    </div>
                    <div className="card-body">
                      <Chart
                        options={state.options}
                        series={state.series}
                        type="bar"
                        height={350}
                      />
                    </div>
                  </div>
                </div>

                {/* Quantity */}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* {showModal && (
        defaultlocationid >0 && locationarray?.length>1 ? "" : 
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog modal-md modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Select Location</h5>
                </div>
                <div className="modal-body">
                  <div className="row">
                    {locations?.map((location, index) => (
                      <>
                        <div className="col-md-12 mb-1">
                          <button className="btn btn-outline-dark w-100" onClick={(e) => { handleModalSubmit(location.LocationID, location.LocationName) }}>{location.LocationName}</button>
                        </div>
                      </>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-backdrop fade show"></div>
        </> 

      )} */}
    </>
  );
};

export default Dashboard;
